<template>
    <div style="height: 100%">
        <vs-chip v-if="params.data.denied" class="mr-3" style="height: 60%; top:20%" color="danger">{{$t("DeniedLetter")}}</vs-chip><vs-chip style="height: 60%; top:20%" :color="statusColor(params.value, params.data.id)">{{params.value}}</vs-chip>
    </div>
</template>
<script>
    import Vue from "vue";

    export default Vue.extend({
        methods:{
            statusColor(status, id) {
                switch (status){
                    case this.$t("Unassigned"):
                        return '#e74c3c';
                    case this.$t("Open"):
                        return '#e67e22';
                    case this.$t("InProgress"):
                        return '#16a085';
                    case this.$t("Waiting"):
                        return '#95a5a6';
                    case this.$t("SentForConfirmation"):
                        return '#3498db';
                    case this.$t("Confirmed"):
                        return '#2ecc71';
                    case this.$t("Invoiced"):
                        return '#9b59b6';
                    default:
                        return 'dark';
                }
            }
        }
    });

</script>
